import ClientCache from "../utils/ClientCache.js";

const LISTS_SCOPE = "list";
const MAX_AGE = 5 * 60000;	// 5 minutes

function listLoader(key, scope) {
	return fetch("./api/lists/"+encodeURIComponent(key))
		.then(response => response.json());
}

export default {
	async getList(id) {
		return await ClientCache.session(LISTS_SCOPE).getOrLoad(id, listLoader, MAX_AGE);
	}
};
